import React, { useEffect, useRef, useState } from 'react';
import { BlindSweepMode, Sweep, PredictionResults } from '../../interfaces';
import {
  Upload,
  Video,
  ChevronRight,
  FileDigit,
  Heart,
  Baby,
  MapPin,
} from 'lucide-react';
import {
  Button,
  Divider,
  Typography,
  Spin,
  Alert,
  Modal,
  Card,
  Row,
  Col,
} from 'antd';
import { useSearchParams } from 'react-router-dom';
import { useGetGlobalReport } from '../../../helpers/api/reports/reports';
import SweepItems from '../../Components/SweepItems/SweepItems';
import BlindSweepReport from '../../Components/BlindSweepReport/BlindSweepReport';
import { useRefreshBlindSweepUrls } from '../../../helpers/api/instance/instance';
import { result } from 'lodash';
import WebSocketService from '../../../services/websocket';

const { Title, Text } = Typography;

function BlindLoops() {
  const [searchParams] = useSearchParams();
  const studyInstanceUIDs = searchParams.get('StudyInstanceUIDs');
  const {
    isLoading: globalReportDataLoading,
    data: globalReportData,
    isError: globalReportDataError,
  } = useGetGlobalReport(studyInstanceUIDs);
  const [studyReport, setStudyReport] = useState<any>(null);
  const [predictionResults, setPredictionResults] =
    useState<PredictionResults | null>(null);
  const [isPredicted, setIsPredicted] = useState<boolean>(false);
  const [mode, setMode] = useState<BlindSweepMode>();
  const [urlExpiryTime, setUrlExpiryTime] = useState<number | null>(null);
  const API =  (window as any).RUNTIME_ENV?.BACKEND_URL ??
  process.env.BACKEND_URL ??
  'http://localhost:8000/api/v1';
  const wsRef = useRef<WebSocketService | null>(null);
  const backendUrl = API;
  const { protocol, host } = new URL(backendUrl);
  const accessToken = localStorage.getItem('access_token');
  const wsUrl = `${protocol.replace(
    'http',
    'ws'
  )}//${host}/ws/ws_model?token=${accessToken}`;
  const [isReportLoading, setIsReportLoading] = useState(true);
  console.log('wsUrl ::', wsUrl);
  const initialSweeps: Sweep[] = [
    {
      id: '1',
      name: 'Sweep 1',
      recording: false,
      timer: 11,
      displayTimer: 10,
      completed: false,
      videoData: null,
      sop_instance_uid: null,
      serie_instance_uid: null,
      study_instance_uid: null,
      prediction_state: null,
      video_url: null,
    },
    {
      id: '2',
      name: 'Sweep 2',
      recording: false,
      timer: 11,
      displayTimer: 10,
      completed: false,
      videoData: null,
      sop_instance_uid: null,
      serie_instance_uid: null,
      study_instance_uid: null,
      prediction_state: null,
      video_url: null,
    },
    {
      id: '3',
      name: 'Sweep 3',
      recording: false,
      timer: 11,
      displayTimer: 10,
      completed: false,
      videoData: null,
      sop_instance_uid: null,
      serie_instance_uid: null,
      study_instance_uid: null,
      prediction_state: null,
      video_url: null,
    },
    {
      id: '4',
      name: 'Sweep 4',
      recording: false,
      timer: 11,
      displayTimer: 10,
      completed: false,
      videoData: null,
      sop_instance_uid: null,
      serie_instance_uid: null,
      study_instance_uid: null,
      prediction_state: null,
      video_url: null,
    },
    {
      id: '5',
      name: 'Sweep 5',
      recording: false,
      timer: 11,
      displayTimer: 10,
      completed: false,
      videoData: null,
      sop_instance_uid: null,
      serie_instance_uid: null,
      study_instance_uid: null,
      prediction_state: null,
      video_url: null,
    },
    {
      id: '6',
      name: 'Sweep 6',
      recording: false,
      timer: 11,
      displayTimer: 10,
      completed: false,
      videoData: null,
      sop_instance_uid: null,
      serie_instance_uid: null,
      study_instance_uid: null,
      prediction_state: null,
      video_url: null,
    },
    {
      id: '7',
      name: 'Sweep 7',
      recording: false,
      timer: 11,
      displayTimer: 10,
      completed: false,
      videoData: null,
      sop_instance_uid: null,
      serie_instance_uid: null,
      study_instance_uid: null,
      prediction_state: null,
      video_url: null,
    },
  ];

  const [sweeps, setSweeps] = useState<Sweep[]>(initialSweeps);

  const [isReportModalOpen, setIsReportModalOpen] = useState(false);
  const showReportModal = () => {
    setIsReportModalOpen(true);
  };
  const handleReportModalClose = () => {
    setIsReportModalOpen(false);
  };
  const {
    isLoading: isRefreshingUrls,
    data: refreshBlindSweepUrlsData,
    isError: refreshBlindSweepUrlsError,
    refetch: refreshBlindSweepUrls,
  } = useRefreshBlindSweepUrls(studyInstanceUIDs);
  const updateSweepsWithNewUrls = (blindsweepUrls: any) => {
    console.log('blindsweepUrls =**', blindsweepUrls);
    setSweeps((prevSweeps) =>
      prevSweeps.map((sweep, index) => {
        const sweepNumber = index + 1;
        const blindSweepKey = `SWEEP${sweepNumber}`;

        // Handle the new URL structure where URLs are directly in the urls object
        const sweepUrl =
          blindsweepUrls &&
          blindsweepUrls.urls &&
          blindsweepUrls.urls[blindSweepKey]
            ? blindsweepUrls.urls[blindSweepKey]
            : null;

        if (sweepUrl) {
          return {
            ...sweep,
            video_url: sweepUrl,
            completed: true,
          };
        }
        return sweep;
      })
    );
  };

  const handleManualRefresh = () => {
    refreshBlindSweepUrls();
    // Reset the expiry time when manually refreshing
    setUrlExpiryTime(Date.now() + 28 * 60 * 1000);
  };

  useEffect(() => {
    if (globalReportData) {
      setStudyReport(globalReportData?.data);
      const studyMode = globalReportData?.data?.study?.study_mode;
      if (studyMode === 'RECORDER') {
        setMode(BlindSweepMode.RECORD);
      } else {
        setMode(BlindSweepMode.UPLOAD);
      }
      setUrlExpiryTime(Date.now() + 28 * 60 * 1000);
    }
  }, [globalReportData]);

  useEffect(() => {
    if (urlExpiryTime && studyInstanceUIDs) {
      const timeUntilRefresh = urlExpiryTime - Date.now() - 5 * 1000;
      const refreshTimer = setTimeout(
        () => {
          refreshBlindSweepUrls();
        },
        Math.max(0, timeUntilRefresh)
      );
      return () => clearTimeout(refreshTimer);
    }
  }, [urlExpiryTime, studyInstanceUIDs, refreshBlindSweepUrls]);

  useEffect(() => {
    if (refreshBlindSweepUrlsData) {
      updateSweepsWithNewUrls(refreshBlindSweepUrlsData?.data);
      setUrlExpiryTime(Date.now() + 28 * 60 * 1000);
    }
  }, [refreshBlindSweepUrlsData]);

  useEffect(() => {
    if (studyReport && studyReport.report_content) {
      const { report_content, blindsweep_urls } = studyReport;
      // Extract prediction results if available
      if (Object.keys(report_content)?.length > 0) {
        const predicted_content = report_content;
        setIsPredicted(true);

        const results: PredictionResults = {};
        if (predicted_content.heart_rate) {
          results.Heart_rate = Math.round(
            predicted_content.heart_rate
          ).toString();
        }
        if (predicted_content.presentation !== undefined) {
          results.fetal_presentation = predicted_content.presentation;
        }
        if (predicted_content.placenta_localization !== undefined) {
          results.Placenta_localization =
            predicted_content.placenta_localization;
        }
        if (predicted_content.Preeclampsia !== undefined) {
          results.preeclampsia = predicted_content.Preeclampsia;
        }
        if (predicted_content.Gestational_diabetes !== undefined) {
          results.gestational_diabetes = predicted_content.Gestational_diabetes;
        }
        if (predicted_content.age !== undefined) {
          results.gestational_age_days = predicted_content.age;
        }
        if (predicted_content.weight !== undefined) {
          results.fetal_weight = predicted_content.weight;
        }
        if (
          predicted_content.sex_prediction !== undefined &&
          predicted_content.sex_prediction !== 'None'
        ) {
          results.fetal_sex = predicted_content.sex_prediction;
        }
        if (predicted_content.is_twins !== undefined) {
          results.is_twins = predicted_content.is_twins;
        }
        if (
          predicted_content.voted_placenta_distance_to_cervix !== undefined &&
          Array.isArray(predicted_content.voted_placenta_distance_to_cervix) &&
          predicted_content.voted_placenta_distance_to_cervix.length > 1
        ) {
          results.placenta_distance =
            predicted_content.voted_placenta_distance_to_cervix[1];
        }
        setPredictionResults(results);
        if (!report_content?.SWEEP1) {
          setIsReportLoading(false);
        }
      }

      const updatedSweeps = initialSweeps.map((sweep, index) => {
        const sweepNumber = index + 1;
        const reportSweepKey = `sweep_${sweepNumber}`;
        const blindSweepKey = `SWEEP${sweepNumber}`;
        const reportSweepData = report_content[reportSweepKey] || {};
        // Get the signed URL for this sweep if available
        const sweepUrl =
          blindsweep_urls &&
          blindsweep_urls?.urls &&
          blindsweep_urls?.urls[blindSweepKey]
            ? blindsweep_urls?.urls[blindSweepKey]
            : null;
        // const sweepUrl = blindsweep_urls &&
        //                 blindsweep_urls[blindSweepKey] ?
        //                 blindsweep_urls[blindSweepKey] : null;

        if (Object.keys(reportSweepData).length > 0) {
          return {
            ...sweep,
            ...reportSweepData,
            completed:
              reportSweepData.videoData || reportSweepData.video_url || sweepUrl
                ? true
                : sweep.completed,
            study_instance_uid:
              studyReport.study_instance_uid || sweep.study_instance_uid,
            video_url: sweepUrl || reportSweepData.video_url,
          };
        }
        return {
          ...sweep,
          study_instance_uid:
            studyReport.study_instance_uid || sweep.study_instance_uid,
          video_url: sweepUrl || sweep.video_url,
          completed: sweepUrl ? true : sweep.completed,
        };
      });

      setSweeps(updatedSweeps);
    }
  }, [studyReport]);

  useEffect(() => {
    console.log('WebSocket URL:', wsUrl);
    console.log('Attempting to create WebSocket connection');

    // Create WebSocket connection
    wsRef.current = new WebSocketService(wsUrl);
    // setIsReportLoading(true);
    // Custom callback to handle incoming messages
    const handleWebSocketMessage = (frameData: string) => {
      try {
        console.log('Callback - Received WebSocket message:', frameData);

        // Parse the message
        const message = JSON.parse(frameData);
        console.log('Callback - Parsed message:', message);

        // Check if it's a prediction succeeded message
        if (message.type === 'prediction_succeeded' && message.data) {
          setStudyReport((prevState) => ({
            ...prevState,
            report_content: message.data.report_content,
          }));
          setIsReportLoading(false);
        }
      } catch (error) {
        console.error('Callback - Error parsing WebSocket message:', error);
        setIsReportLoading(false);
      }
    };

    // Set the frame callback directly
    wsRef.current.setOnFrameCallback(handleWebSocketMessage);

    // Connect to WebSocket
    wsRef.current.connect();

    // Cleanup function
    return () => {
      // Disconnect WebSocket
      wsRef.current?.disconnect();
    };
  }, [wsUrl]);

  useEffect(() => {
    console.log('studyReport ::', studyReport);
  }, [studyReport]);

  if (globalReportDataLoading) {
    return (
      <div className="w-full h-full flex flex-col items-center justify-center dui-bg-base-100 border-2 border-blue-100">
        <Spin size="large" tip="Loading report data..." />
      </div>
    );
  }

  if (globalReportDataError) {
    return (
      <div className="w-full h-full flex flex-col items-center justify-center dui-bg-base-100 border-2 border-blue-100 p-6">
        <Alert
          message="Error Loading Report"
          description="There was a problem loading the report data. Please try again later or contact support."
          type="error"
          showIcon
        />
        <Button
          type="primary"
          className="mt-4 bg-blue-600 hover:bg-blue-700"
          onClick={() => window.location.reload()}
        >
          Try Again
        </Button>
      </div>
    );
  }

  return (
    <div className="w-full h-full flex flex-col dui-bg-base-100 border-2 border-blue-100">
      <div className="h-full flex flex-col">
        {/* <div className="bg-gradient-to-r from-blue-50 to-white p-3 sm:p-4 md:p-5 lg:p-6 border-b border-blue-100">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 sm:gap-4 w-full">
            <div>
              <Title
                level={3}
                className="text-blue-800 m-0 text-lg sm:text-xl md:text-2xl lg:text-3xl"
              >
                Medical BlindSweep Imaging System
              </Title>
              <Text className="text-blue-600 text-xs sm:text-sm md:text-base">
                Start Sweeping
              </Text>
            </div>
            <Button
              type="primary"
              size="large"
              className="bg-blue-600 hover:bg-blue-700 border-blue-700 flex items-center text-xs sm:text-sm md:text-base"
              onClick={showReportModal}
            >
              Report
            </Button>
          </div>
        </div> */}

        {/* {studyReport && studyReport.data && studyReport.data.patient && (
                    <div className="bg-blue-50 p-3 border-b border-blue-100">
                        <div className="flex flex-wrap gap-4">
                            <div>
                                <Text className="text-blue-500 text-xs">Patient ID:</Text>
                                <Text className="ml-2 font-medium">{studyReport.data.patient.patient_id}</Text>
                            </div>
                            <div>
                                <Text className="text-blue-500 text-xs">Name:</Text>
                                <Text className="ml-2 font-medium">
                                    {studyReport.data.patient.patient_name} {studyReport.data.patient.patient_last_name}
                                </Text>
                            </div>
                            <div>
                                <Text className="text-blue-500 text-xs">Study Date:</Text>
                                <Text className="ml-2 font-medium">
                                    {new Date(studyReport.data.study.study_date).toLocaleDateString()}
                                </Text>
                            </div>
                        </div>
                    </div>
                )} */}

        {isRefreshingUrls && (
          <div className="absolute top-2 right-2 z-50 bg-blue-100 text-blue-800 px-3 py-1 rounded-md text-sm">
            Refreshing video links...
          </div>
        )}

        <div className="flex-1 overflow-auto">
          <SweepItems
            sweeps={sweeps}
            setSweeps={setSweeps}
            mode={mode || BlindSweepMode.UPLOAD}
            onPrevious={() => {}}
            showNavigation={true}
            isPredicted={isPredicted}
            setStudyReport={setStudyReport}
            onRefreshUrls={handleManualRefresh}
            isRefreshingUrls={isRefreshingUrls}
            urlExpiryTime={urlExpiryTime}
            showReportModal={showReportModal}
            isReportLoading={isReportLoading}
            predictionResults={predictionResults}
          />
        </div>
      </div>
      {/* Report Modal */}
      {/* <Modal
        title={null}
        open={isReportModalOpen}
        onCancel={handleReportModalClose}
        footer={null}
        width="90%"
        style={{ maxWidth: '1200px' }}
        centered
      > */}
      <BlindSweepReport
        isOpen={isReportModalOpen}
        onClose={handleReportModalClose}
        predictionResults={predictionResults}
        handleReportModalClose={handleReportModalClose}
      />
      {/* </Modal> */}
    </div>
  );
}

export default BlindLoops;
